(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', '@material-ui/core/styles', '@material-ui/core/IconButton', '../../elements', './Tooltip', '../../elements/typography', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('@material-ui/core/styles'), require('@material-ui/core/IconButton'), require('../../elements'), require('./Tooltip'), require('../../elements/typography'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.styles, global.IconButton, global.elements, global.Tooltip, global.typography, global.styles);
    global.InfoTooltip = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _styles, _IconButton, _elements, _Tooltip, _typography, _styles2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  var _IconButton2 = _interopRequireDefault(_IconButton);

  var _Tooltip2 = _interopRequireDefault(_Tooltip);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 1rem;\n  '], ['\n    height: 1rem;\n  ']);

  var InfoTooltip = function InfoTooltip(_ref) {
    var content = _ref.content,
        placement = _ref.placement,
        classes = _ref.classes,
        dataTestId = _ref.dataTestId;
    return React.createElement(
      _Tooltip2.default,
      {
        placement: placement,
        content: React.createElement(
          _typography.Note,
          { light: true },
          content
        ),
        disableHoverListener: true,
        'data-testid': dataTestId
      },
      React.createElement(
        _IconButton2.default,
        {
          'aria-label': 'More Information',
          classes: { colorInherit: classes.overrides, root: classes.root },
          TouchRippleProps: { classes: { root: classes.leaf } }
        },
        React.createElement(_elements.MaterialIcon, { name: 'help_outline', className: classNames.icon })
      )
    );
  };

  InfoTooltip.defaultProps = {
    placement: 'top'
  };

  var classNames = {
    icon: (0, _emotion.css)(_templateObject)
  };

  var styles = {
    root: {
      lineHeight: 1,
      verticalAlign: 'baseline',
      '&:hover': {
        backgroundColor: 'rgba(97, 193, 108, 0.15)'
      },
      '&:focus': {
        outline: 'none'
      }
    },
    overrides: {
      color: _styles2.colors.prussian
    },
    leaf: {
      color: _styles2.colors.leaf
    }
  };

  exports.default = (0, _styles.withStyles)(styles)(InfoTooltip);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tooltip/InfoTooltip.js
// module id = 1998
// module chunks = 1